import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";

export const parseWkt = (wktPoint: string): Point | null => {
    const regex = /POINT ?\(\s*([-\d.]+)\s+([-\d.]+)\s*\)/;
    const match = wktPoint.match(regex);

    if (match && match.length === 3) {
        const lng = parseFloat(match[1]);
        const lat = parseFloat(match[2]);
        if (!isNaN(lng) && !isNaN(lat)) {
            return new Point(fromLonLat([lng, lat]))
        }
    }

    return null;
}

export const parseEnvelopeWKT = (wkt: string): number[] | null => {
    const matches = wkt.match(/POLYGON\(\((.+)\)\)/)
    if (!matches) return null
    const coords = matches[1].split(',').map(pair => {
        const parts = pair.trim().split(' ')
        return [parseFloat(parts[0]), parseFloat(parts[1])]
    })
    if (coords.length < 3) return null
    return [coords[0][0], coords[0][1], coords[2][0], coords[2][1]]
}